import type { TFunction } from 'i18next';
import type { Path } from 'react-hook-form';
import { number } from 'yup';
import { emptyStringToNull } from '../emptyStringToNullable.ts';
import { FLOAT_NUMBER_WITH_MAX_TWO_DECIMALS } from '../validationRegexes.ts';

type CreateCpmFieldSchemaParameters<TFormData> = {
  field: Path<TFormData>;
  labels: Record<string, string>;
  t: TFunction;
};

export const createCpmFieldSchema = <TFormData>({ field, labels, t }: CreateCpmFieldSchemaParameters<TFormData>) => {
  return number()
    .nullable()
    .transform(emptyStringToNull)
    .typeError(t('{field} has to be a number', { field: labels[field] }))
    .min(0, t('{field} must be greater than or equal to 0', { field: labels[field] }))
    .test({
      message: t('{field} may contain only 2 digits after decimal point', { field: labels[field] }),
      name: 'maxTwoDigitAfterDecimal',
      test: value => FLOAT_NUMBER_WITH_MAX_TWO_DECIMALS.test(value?.toString() ?? '0'),
    });
};
